import { message } from 'antd';
import { deleteAlert } from '@src/api/manualAlerts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { trackQueryError } from '@src/utils/sensor/apptracker';

const useDelete = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (alertId) => {
      return deleteAlert(alertId);
    },
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries(['manual-alert', 'list']);
        if (response.data === 'OK') {
          message.success(`Alert deleted!`);
        }
      },
      onError: (err) => {
        trackQueryError({ type: 'manual-alert-toggle', err });
      },
    },
  );

  return mutation;
};

export default useDelete;
